<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },
  
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => {
        return ['won', 'lost', 'reopen'].includes(value);
      }
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data () {
    return {
      closingBySave: false,
    }
  },

  mounted() {
    Bus.$on('openDealActionModal', () => this.handleOpen());
    Bus.$on('closeDealActionModal', (dealUpdated) => this.handleClose(dealUpdated));
  },
   
  computed: {
    hasReason() {
      return ['won', 'lost'].includes(this.type);
    },
    dialogClass() {
      return this.type === 'reopen' ? 'reopen-dialog' : '';
    }
  },

  methods: {
    handleSave() {
      this.$emit('save');
    },

    handleOpen() {
      this.$refs['deal-action-modal'].show();
    },
    
    handleClose(dealUpdated) {
      if(dealUpdated) {
        this.closingBySave = true;
      }
      this.$refs['deal-action-modal'].hide();
    },

    onClose() {
      if(!this.closingBySave) {
        Bus.$emit('reinsertDeal');
      }
      this.closingBySave = false;
    }
  }
}
</script>

<template>
  <BModal 
  id="deal-action-modal"
  ref="deal-action-modal"
  centered
  hide-header
  hide-footer
  :dialog-class="dialogClass"
  @hide="onClose"
  >
    <div>
      <h1>{{ __(title) }}</h1>
      <h2>{{ __(description) }}</h2>
      <img :src="`/build/images/deal/${type}.svg`" class="mx-auto d-block"/>
    </div>
    <slot name="form"></slot>
    <p v-if="hasReason">
      {{ __('Não encontrou o motivo?') }}
      <a :href="`/settings#/nav-${type}-reason`">
        {{ __('Configure aqui!') }}
      </a>
    </p>
    <div class="btn-group">
      <button :disabled="loading" @click="handleSave">
        {{ __('Salvar') }}
      </button>
      <span @click="handleClose(false)">
        {{ __('Cancelar') }}
      </span>
    </div>
  </BModal>
</template>

<style lang="scss" scoped>
#deal-action-modal {
  color: #242424;
  font-family: Montserrat;
}

header {
  width: 100%;
  display: flex;
  justify-content: end;
}

h1 {
  font-size: 24px;
  font-weight: 600;
  line-height: 150%;
  text-align: center;
  max-width: 314px;
  margin: auto;
  margin-bottom: 0;
}

h2 { 
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: center;
  margin: 0;
}

img {
  height: auto;
  width: auto;
  max-width: 100%;
  margin-top: 16px;
  margin-bottom: -16px;
}

p {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  margin: 0;

  a {
    color: #7E5DF4;
    font-weight: 600;
    cursor: pointer;
  }
}

.btn-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 32px;
    width: 140px;
    border-radius: 14px;
    border: 1px solid #2CEBA9;
    background: #2CEBA9;
    font-size: 16px;
    font-weight: 600;
  }

  button:hover {
    background: #1DC38A;
    border: 1px solid #1DC38A;
    color: #FFF;
  }

  button:disabled {
    cursor: not-allowed;
  }
  
  span {
    width: 72px;
    height: 18px;
    padding: 0px 8px 0px 9px;
    color: #71767D;
    font-size: 12px;
    font-weight: 600;
    text-decoration-line: underline;
    text-align: center;
    line-height: 150%;
    cursor: pointer;
  }
}
</style>